module.exports = JSON.parse("{\"timestamp\":\"21.10.2026 - 11:34:56\",\"brands\":[]}")